import React, { useState } from 'react';
import styled from 'styled-components';
import { Icon } from './Icon';
import { FaQuestionCircle } from 'react-icons/fa';
import { HelpModal } from './HelpModal';

const StyledHelpButton = styled.button`
  background: transparent;
  border: none;
  color: #6c757d;
  cursor: pointer;
  font-size: 18px;
  padding: 8px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  
  &:hover {
    color: #007bff;
    background-color: rgba(0, 123, 255, 0.1);
    transform: scale(1.1);
  }
  
  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
  }
`;

interface HelpButtonProps {
  title: string;
  content: string;
  className?: string;
  size?: 'small' | 'medium' | 'large';
  position?: 'inline' | 'fixed-bottom-right';
}

export const HelpButton: React.FC<HelpButtonProps> = ({
  title,
  content,
  className,
  size = 'medium',
  position = 'inline'
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const getSizeStyles = () => {
    switch (size) {
      case 'small':
        return { fontSize: '14px', padding: '6px' };
      case 'large':
        return { fontSize: '22px', padding: '12px' };
      default:
        return { fontSize: '18px', padding: '8px' };
    }
  };

  const getPositionStyles = () => {
    if (position === 'fixed-bottom-right') {
      return {
        position: 'fixed' as const,
        bottom: '20px',
        right: '20px',
        zIndex: 1000,
        backgroundColor: '#007bff',
        color: 'white',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
        '&:hover': {
          backgroundColor: '#0056b3',
          color: 'white'
        }
      };
    }
    return {};
  };

  return (
    <>
      <StyledHelpButton
        className={className}
        onClick={() => setIsModalOpen(true)}
        style={{ ...getSizeStyles(), ...getPositionStyles() }}
        title="Get help"
        type="button"
      >
        <Icon icon={FaQuestionCircle} />
      </StyledHelpButton>
      
      <HelpModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        title={title}
        content={content}
      />
    </>
  );
};